import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import { toastGuidQueryKeys } from './useToastGuids';

export interface DeleteToastGuidVariables {
  id: string;
}

export function useDeleteToastGuid(
  options?: UseMutationOptions<void, Error, DeleteToastGuidVariables>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['toastGuid', 'delete'],
    mutationFn: async ({ id }: DeleteToastGuidVariables) => {
      return service.deleteToastGuid(id);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: toastGuidQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
